import React from "react";
import { Buttonlogin, SectionWrapper } from "./LoginPageForm.styled";
import { Col, Form } from "react-bootstrap";
import UsersIcon from "../../assets/svg/person-icon.svg";
import PasswordIcon from "../../assets/svg/password-icon.svg";
import PropTypes from "prop-types";

const LoginPageForm = ({
  handleInput,
  SignIn,
  handleLogin,
  authenticationMethod,
  setAuthenticationMethod,
}) => {
  return (
    <SectionWrapper
      className="col-md-10"
      usernameIcon={UsersIcon}
      passwordIcon={PasswordIcon}
    >
      <p>Sign in</p>
      <select
        defaultValue={authenticationMethod}
        onChange={(e) => {
          setAuthenticationMethod(e.target.value);
        }}
      >
        <option value={1} hidden={true}>
          CCMS
        </option>
        <option value={2}>Tp Id</option>
      </select>

      {authenticationMethod == 1 && (
        <div
          id="groupdata"
          style={{ height: "fit-content", marginTop: "20px", width: "100%" }}
        >
          <Form>
            <Form.Group as={Col} md="12">
              <Form.Control
                type="text"
                className="username-field"
                name="username"
                id="inputUsername"
                placeholder="Enter your username"
                required="required"
                autoComplete={"off"}
                onChange={handleInput}
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="12" style={{ marginTop: "2%" }}>
              <Form.Control
                type="password"
                name="password"
                className="password-field"
                id="inputPassword"
                placeholder="Enter your password"
                required="required"
                autoComplete={"off"}
                onChange={handleInput}
              ></Form.Control>
            </Form.Group>
          </Form>
        </div>
      )}
      <Buttonlogin
        onClick={() => {
          if (authenticationMethod == 1) {
            SignIn();
          } else {
            handleLogin();
          }
        }}
      >
        LOGIN
      </Buttonlogin>
    </SectionWrapper>
  );
};

export default LoginPageForm;

LoginPageForm.propTypes = {
  handleInput: PropTypes.func,
  SignIn: PropTypes.func,
  handleLogin: PropTypes.func,
  authenticationMethod: PropTypes.number,
  setAuthenticationMethod: PropTypes.func,
};
